import IosPwaInstallPrompt from './IosPwaInstallPrompt';
export default IosPwaInstallPrompt;